import * as React from 'react';
import { classNames, warnOnce } from '../../utils/utils';
export const ShuttleItem = React.forwardRef(({ children, className, disabled, value, selected, ...rest }, ref) => {
    if (typeof rest['data-index'] !== 'number') {
        warnOnce('data-index is missing from Shuttle.Item. Did you forget to pass getItemProps to the item?');
    }
    return (React.createElement("div", Object.assign({ className: classNames('shuttle__item', {
            'shuttle__item--disabled': disabled,
            'shuttle__item--selected': selected,
        }, className), "data-value": value, "data-disabled": disabled || undefined, role: "option", "aria-selected": !!selected, tabIndex: -1, ref: ref }, rest), children));
});
ShuttleItem.displayName = 'Shuttle.Item';
